<div class="block">
  <h3 class="dsm34-headline-6--book dsm34--mb-xs">Dados gerais</h3>
  <div class="dsm34__row">
    <div class="dsm34__col--12" [ngClass]="{ 'cpe-field': viewModel?.showProcessIdentification }">
      <dsm34-form-field>
        <dsm34-label>{{ viewModel?.placeHolderCPE }}</dsm34-label>
        <input
          dsm34-input
          type="text"
          [formControl]="$any(viewModel?.formGroup.get(viewModel?.formNameCPE))"
          id="{{ viewModel?.formNameCPE }}"
          aria-label="{{ viewModel?.placeHolderCPE }}"
        />
        @if ($any(viewModel?.formGroup.get(viewModel?.formNameCPE)).hasError('required')) {
          <dsm34-error> {{ viewModel?.errorsMessageCPE.required }} </dsm34-error>
        }
        @if ($any(viewModel?.formGroup.get(viewModel?.formNameCPE)).hasError('invalidCpe')) {
          <dsm34-error> {{ viewModel?.errorsMessageCPE.invalidCpe }} </dsm34-error>
        }
        @if ($any(viewModel?.formGroup.get(viewModel?.formNameCPE)).hasError('invalidPn')) {
          <dsm34-error> {{ viewModel?.errorsMessageCPE.invalidPn }} </dsm34-error>
        }
        @if ($any(viewModel?.formGroup.get(viewModel?.formNameCPE)).hasError('invalidCpeProduction')) {
          <dsm34-error> {{ viewModel?.errorsMessageCPE.invalidCpeProduction }} </dsm34-error>
        }
        @if ($any(viewModel?.formGroup.get(viewModel?.formNameCPE)).hasError('invalidCpeDifferentNetwork')) {
          <dsm34-error> {{ viewModel?.errorsMessageCPE.invalidCpeDifferentNetwork }} </dsm34-error>
        }
      </dsm34-form-field>
    </div>
    @if (viewModel?.showProcessIdentification) {
      <div class="dsm34__col--12">
        <dsm34-form-field>
          <dsm34-label>{{ viewModel?.placeHolderProcessIdentification }}</dsm34-label>
          <input
            dsm34-input
            type="text"
            [formControl]="$any(viewModel?.formGroup.get(viewModel?.formNameProcessIdentification))"
            id="{{ viewModel?.formNameProcessIdentification }}"
            aria-label="{{ viewModel?.placeHolderProcessIdentification }}"
          />
          @if ($any(viewModel?.formGroup.get(viewModel?.formNameProcessIdentification)).hasError('required')) {
            <dsm34-error> {{ viewModel?.errorsMessageProcessIdentification.required }} </dsm34-error>
          }
          @if (
            $any(viewModel?.formGroup.get(viewModel?.formNameProcessIdentification)).hasError(
              'invalidProcessIdentifier'
            )
          ) {
            <dsm34-error> {{ viewModel?.errorsMessageProcessIdentification.invalidProcessIdentifier }} </dsm34-error>
          }
        </dsm34-form-field>
      </div>
    }
    @if (viewModel?.selectedNif || viewModel?.messageErrorPartnerNumber) {
      <div class="dsm34__col--12">
        <div class="fields dsm34--gap-xs">
          <div class="w-100 read-field">
            <label for="selectedNif" class="dsm34-body-2--bold dsm34--neutral-darker-grey dsm34--mb-xs"
              >NÚMERO DE IDENTIFICAÇÃO FISCAL</label
            >
            <input id="selectedNif" type="text" [value]="viewModel?.selectedNif" readonly />
            @if (viewModel?.messageErrorPartnerNumber) {
              <dsm34-error> {{ viewModel?.messageErrorPartnerNumber }} </dsm34-error>
            }
          </div>

          <div class="w-100 read-field">
            <label for="selectedName" class="dsm34-body-2--bold dsm34--neutral-darker-grey dsm34--mb-xs">NOME</label>
            <input id="selectedName" type="text" [value]="viewModel?.selectedName" readonly />
            @if (viewModel?.messageErrorPartnerNumber) {
              <dsm34-error> {{ viewModel?.messageErrorPartnerNumber }} </dsm34-error>
            }
          </div>

          <div class="w-100 wrapper-button-change dsm34--d-flex dsm34--align-items-end dsm34--justify-content-end">
            <button type="button" dsm34-button--outline color="black" (click)="openModalAction()">Alterar</button>
          </div>
        </div>
      </div>
    }
  </div>
  @if (viewModel?.showBillingdDate) {
    <div class="dsm34--mt-md">
      <h3 class="dsm34-headline-6--book dsm34--mb-xs">Data de faturação pretendida</h3>
      <div class="dsm34__row">
        <div class="dsm34__col--12">
          <dsm34-form-field>
            <dsm34-label>{{ viewModel?.placeHolderBillingDate }}</dsm34-label>
            <input
              dsm34-input
              type="text"
              [formControl]="$any(viewModel?.formGroup.get(viewModel?.formNameBillingDate))"
              id="{{ viewModel?.formNameBillingDate }}"
              aria-label="{{ viewModel?.placeHolderBillingDate }}"
              dsm34Mask="99"
              maxlength="2"
            />
            @if ($any(viewModel?.formGroup.get(viewModel?.formNameBillingDate)).hasError('required')) {
              <dsm34-error> {{ viewModel?.errorsMessageBillingDate.required }} </dsm34-error>
            }
            @if ($any(viewModel?.formGroup.get(viewModel?.formNameBillingDate)).hasError('max')) {
              <dsm34-error> {{ viewModel?.errorsMessageBillingDate.max }} </dsm34-error>
            }
            @if (
              $any(viewModel?.formGroup.get(viewModel?.formNameBillingDate)).hasError('min') &&
              !$any(viewModel?.formGroup.get(viewModel?.formNameBillingDate)).hasError('minlength')
            ) {
              <dsm34-error> {{ viewModel?.errorsMessageBillingDate.min }} </dsm34-error>
            }
            @if ($any(viewModel?.formGroup.get(viewModel?.formNameBillingDate)).hasError('minlength')) {
              <dsm34-error> {{ viewModel?.errorsMessageBillingDate.minlength }} </dsm34-error>
            }
          </dsm34-form-field>
        </div>
      </div>
    </div>
  }
  <ng-template #templateModalNifOptions>
    <div class="wrapper-modal-content">
      <div class="title">
        <h1>{{ viewModel?.modalTitle }}</h1>
      </div>

      <div class="wrapper-radio">
        <div *ngIf="contracts.length > 1">
          <scc-dsm3-radio-button-control
            [formGroup]="viewModel?.formGroup"
            [formName]="viewModel?.formNamePartnerNumber"
            [options$]="nifOptions$"
            label="Selecione um dos NIF"
          >
          </scc-dsm3-radio-button-control>
        </div>

        @if (viewModel?.showAnotherNif) {
          <dsm34-form-field>
            <dsm34-label>Insira o NIF de cliente pretendido</dsm34-label>
            <input
              dsm34-input
              type="text"
              maxlength="20"
              [formControl]="$any(viewModel?.formGroup.get(viewModel?.formNameAnotherNif))"
              id="new_nif"
              aria-label="Insira o NIF de cliente pretendido"
            />
            @if ($any(viewModel?.formGroup.get(viewModel?.formNameAnotherNif)).hasError('required')) {
              <dsm34-error> {{ viewModel?.errorMessageAnotherNif.required }} </dsm34-error>
            }
            @if ($any(viewModel?.formGroup.get(viewModel?.formNameAnotherNif)).hasError('invalidTaxNumber')) {
              <dsm34-error> {{ viewModel?.errorMessageAnotherNif.invalidTaxNumber }} </dsm34-error>
            }
            @if ($any(viewModel?.formGroup.get(viewModel?.formNameAnotherNif)).hasError('invalidTaxNumberPrefix')) {
              <dsm34-error> {{ viewModel?.errorMessageAnotherNif.invalidTaxNumberPrefix }} </dsm34-error>
            }
          </dsm34-form-field>
        }
      </div>

      <div class="wrapper-button">
        <button type="button" dsm34-button--outline color="black" (click)="closeModal()">Cancelar</button>

        <button
          type="button"
          dsm34-button--filled
          [disabled]="
            !viewModel?.formGroup.get(viewModel?.formNamePartnerNumber).value ||
            !viewModel?.formGroup.get(viewModel?.formNameAnotherNif).valid
          "
          (click)="choose()"
        >
          Escolher
        </button>
      </div>
    </div>
  </ng-template>
</div>
